<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import { useJoakimStore } from '@/stores/useJoakimStore'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step1 from './Steps/Step1.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Step7 from './Steps/Step7.vue'
import PEP from '../Shared/PEP.vue'
import Undirritun from '../Shared/Undirritun.vue'
import ApplicationMakaLifeyriBegin from './Steps/ApplicationMakaLifeyriBegin.vue'

const joakim = useJoakimStore()

async function runBankCheck(umsokn: any) {
  const res = await joakim.checkBankaReikning(umsokn)
  const data = (res as any)?.data ?? res
  const valid = !!data?.valid
  return { valid, errorMessage: valid ? '' : (data?.message || 'Ógildur bankareikningur') }
}

const steps = [
  { comp: ApplicationMakaLifeyriBegin,  titleKey: '' },
  { comp: Step1,        titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,        titleKey: 'makalifeyrir_umsokn_step2_header' },
  { comp: Step3,        titleKey: 'makalifeyrir_umsokn_step3_header' },
  { comp: Step4,        titleKey: 'makalifeyrir_umsokn_step5_header', props: { runBankCheck } },
  { comp: PEP,          titleKey: 'umsokn_PEP_header' },
  { comp: Step5,        titleKey: 'makalifeyrir_umsokn_step5_header' },
  { comp: Step6,        titleKey: 'makalifeyrir_umsokn_step6_header' },
  { comp: Step7,        titleKey: 'umsokn_samantekt_header' },
  { comp: Undirritun,   titleKey: 'undirritun_umsokn_header1' },
]
</script>

<template>
  <ApplicationBase :app-id="13" update-key="makalifeyrir" :steps="steps" />
</template>
